import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { container } from "tsyringe";
import ApplicationConfig from "configs/ApplicationConfig";

interface RecaptchaResult {
	token?: string;
	error?: string;
}

/**
 * Custom hook to simplify reCAPTCHA token generation
 */
export const useRecaptcha = () => {
	const { executeRecaptcha: executeRecaptchaOriginal } = useGoogleReCaptcha();
	const applicationConfig = container.resolve(ApplicationConfig);
	const config = applicationConfig.get();

	const executeRecaptcha = async (action: string): Promise<RecaptchaResult> => {
		// Check if reCAPTCHA is enabled in config
		if (!config.recaptcha.enabled) {
			return { token: undefined };
		}

		// Check if reCAPTCHA is loaded
		if (!executeRecaptchaOriginal) {
			return {
				error: "reCAPTCHA not loaded yet. Please try again.",
			};
		}

		try {
			const token = await executeRecaptchaOriginal(action);
			return { token };
		} catch (error) {
			console.error("reCAPTCHA execution error:", error);
			return {
				error: "Failed to verify reCAPTCHA. Please try again.",
			};
		}
	};

	return { executeRecaptcha };
};
